import * as types from "../constants/ActionTypes";

const initialState = {
  dealers: []
};

export function fetchDealers(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_DEALERS_SUCCESS:
      return {
        ...state,
        dealers: action.payload,
      }
    default:
      return state
  }
}
